import { initialSupplierFormValues, SupplierFormValues } from 'src/types/manage-suppliers/SupplierForm';

export type CreateOfflineSupplierFormValues = Omit<SupplierFormValues, 'status'>;

const { status: _status, ...initialCreateOfflineSupplierFormValues } = initialSupplierFormValues;

export { initialCreateOfflineSupplierFormValues };
